import { SortableElement } from "react-sortable-hoc";
import React from "react";

const SortableItem = SortableElement(({ children }) => <li className="experiences-item">{children}</li>);

export default SortableItem;
